import React from "react";
import { CFormGroup, CInputCheckbox, CLabel } from "@coreui/react";

import QuestionWrapper from "./QuestionWrapper";
import { useEffect } from "react";
import { DATA_COLLECTION } from "../../constants/data-collection";

const DataCollectionQuestions = ({ onChange, values, errors, area }) => {
  const inputProps = {
    onChange,
    values,
    errors,
  };

  const numberOfErrors = Object.keys(errors).length;

  useEffect(() => {
    if (numberOfErrors > 0) {
      const firstErrorField = Object.keys(errors)[0];
      const errorElement = document.getElementById(firstErrorField);
      errorElement?.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [numberOfErrors, errors]);

  const areaQuestions = DATA_COLLECTION(inputProps)[area];

  if (!areaQuestions) {
    return null;
  }

  const questionLabels = DATA_COLLECTION(inputProps)
    [area].filter((i) => i.component)
    .map((item) => item.label);


  return (
    <div>
      <p
        style={{ fontSize: "22px" }}
        className="font-bold text-center text-info mb-3"
      >
        Data collection
      </p>
      <p className="text-center">
        This questions are standardised to allow for single collection from you
        to provide to multiple stakeholders (agencies, customers etc).
      </p>
      <p className="text-center">
        These are unscored questions and will not impact your Business Impact
        Tracker ESG score. If you have been requested by a customer to provide
        this information, and you are happy to disclose it please ensure you
        tick the appropriate box below
      </p>
      <CFormGroup className="my-3 w-100" variant="custom-checkbox">
        <CInputCheckbox
          custom
          id="permission-to-share"
          name="permission-to-share"
          onChange={onChange}
          defaultChecked={values["permission-to-share"]}
          style={{ borderRadius: 0 }}
        />
        <CLabel
          style={{ fontSize: "18px" }}
          variant="custom-checkbox"
          htmlFor="permission-to-share"
        >
          I am happy to share this information
        </CLabel>
      </CFormGroup>
      <div className="d-flex flex-column align-items-start py-3">
        {DATA_COLLECTION(inputProps)[area].map((item, idx) => (
          <>
            {!!item.component ? (
              <QuestionWrapper
                idx={questionLabels.indexOf(item.label)}
                key={idx}
                label={item.label}
                name={item.name}
                info={item.info}
                values={values}
                onChange={onChange}
              >
                {item.component}
              </QuestionWrapper>
            ) : (
              <p style={{ fontSize: "20px", fontWeight: 600 }}>{item.label}</p>
            )}
          </>
        ))}
      </div>
    </div>
  );
};

export default DataCollectionQuestions;
